import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  wrapper: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    padding: '0 1.5rem 0.75rem',
  },
  title: {
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '1.5rem',
    color: neutral[60],
    textTransform: 'uppercase',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    color: neutral[100],
    '& > h2': {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      '& > span:first-of-type': {
        paddingRight: '0.25rem',
      },
    },
    '& > span': {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: '1.5rem',
    },
  },
  description: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
  },
});
